module.exports = __webpack_public_path__ + "img/fashion.f31f87de.jpg";